'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 });
var _rel = require('./rel');
Object.keys(_rel).forEach(function (e) {
    'default' !== e && '__esModule' !== e && Object.defineProperty(exports, e, {
        enumerable: !0,
        get: function () {
            return _rel[e];
        }
    });
});
var _callNewApp = require('./callNewApp');
Object.keys(_callNewApp).forEach(function (e) {
    'default' !== e && '__esModule' !== e && Object.defineProperty(exports, e, {
        enumerable: !0,
        get: function () {
            return _callNewApp[e];
        }
    });
});
var _h5PageCount = require('./h5PageCount');
Object.keys(_h5PageCount).forEach(function (e) {
    'default' !== e && '__esModule' !== e && Object.defineProperty(exports, e, {
        enumerable: !0,
        get: function () {
            return _h5PageCount[e];
        }
    });
});
var _transform = require('./transform');
Object.keys(_transform).forEach(function (e) {
    'default' !== e && '__esModule' !== e && Object.defineProperty(exports, e, {
        enumerable: !0,
        get: function () {
            return _transform[e];
        }
    });
});
var _handleAd = require('./handleAd');
Object.keys(_handleAd).forEach(function (e) {
    'default' !== e && '__esModule' !== e && Object.defineProperty(exports, e, {
        enumerable: !0,
        get: function () {
            return _handleAd[e];
        }
    });
});
var _handleTjLink = require('./handleTjLink');
Object.keys(_handleTjLink).forEach(function (e) {
    'default' !== e && '__esModule' !== e && Object.defineProperty(exports, e, {
        enumerable: !0,
        get: function () {
            return _handleTjLink[e];
        }
    });
});
var _callVideoApp = require('./callVideoApp');
Object.keys(_callVideoApp).forEach(function (e) {
    'default' !== e && '__esModule' !== e && Object.defineProperty(exports, e, {
        enumerable: !0,
        get: function () {
            return _callVideoApp[e];
        }
    });
});
var _linkedMeVideoApp = require('./linkedMeVideoApp');
Object.keys(_linkedMeVideoApp).forEach(function (e) {
    'default' !== e && '__esModule' !== e && Object.defineProperty(exports, e, {
        enumerable: !0,
        get: function () {
            return _linkedMeVideoApp[e];
        }
    });
});
var _createUid = require('./createUid');
Object.keys(_createUid).forEach(function (e) {
    'default' !== e && '__esModule' !== e && Object.defineProperty(exports, e, {
        enumerable: !0,
        get: function () {
            return _createUid[e];
        }
    });
});
var _handleStick = require('./handleStick');
Object.keys(_handleStick).forEach(function (e) {
    'default' !== e && '__esModule' !== e && Object.defineProperty(exports, e, {
        enumerable: !0,
        get: function () {
            return _handleStick[e];
        }
    });
});
var _handlePageBack = require('./handlePageBack');
Object.keys(_handlePageBack).forEach(function (e) {
    'default' !== e && '__esModule' !== e && Object.defineProperty(exports, e, {
        enumerable: !0,
        get: function () {
            return _handlePageBack[e];
        }
    });
});